<script setup>
import { Share2 } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import BaseModal from './BaseModal.vue'
import ClaimInstructionsCard from './ClaimInstructionsCard.vue'

const { t: $t } = useI18n()

const props = defineProps({
  open: {
    type: Boolean,
    default: false
  },
  claimUrl: {
    type: String,
    required: true
  },
  emojiPin: {
    type: String,
    required: true
  },
  walletAddress: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['close'])

const close = () => {
  emit('close')
}
</script>

<template>
  <BaseModal
    :open="open"
    max-width="512px"
    @close="close"
  >
    <template #header>
      <div class="flex items-center gap-2">
        <Share2 :size="24" class="text-green-500" />
        <h2 class="text-xl font-bold text-gray-900">
          {{ $t('share.title', 'Share Gift Card') }}
        </h2>
      </div>
    </template>

    <!-- Content -->
    <div class="share-modal-body">
      <!-- Claim Instructions Card -->
      <ClaimInstructionsCard
        :claim-url="claimUrl"
        :emoji-pin="emojiPin"
        :wallet-address="walletAddress"
      />
    </div>
  </BaseModal>
</template>

<style scoped>
.share-modal-body {
  @apply flex flex-col gap-5;
}
</style>
